import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { observer } from "mobx-react";
import copilotStore from "Stores/copilotStore";

const formatWhen = ts => {
  if (!ts) return "";
  const then = new Date(ts);
  const now = new Date();
  const sameDay = then.toDateString() === now.toDateString();
  if (sameDay) {
    return then.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  }
  return then.toLocaleDateString([], { month: "short", day: "numeric" });
};

const HistoryDrawer = observer(() => {
  const history = useHistory();
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState("");
  if (!copilotStore.historyOpen) return null;

  const openChat = id => {
    if (editingId) return; // don't navigate while renaming
    copilotStore.historyOpen = false;
    history.push(`/copilot/${id}`);
  };

  const startEdit = item => {
    setEditingId(item.id);
    setEditValue(item.title || "");
  };

  const commitEdit = () => {
    if (editingId) copilotStore.renameConversation(editingId, editValue);
    setEditingId(null);
    setEditValue("");
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditValue("");
  };

  return (
    <div
      className="copilotHistory"
      onMouseEnter={copilotStore.openHistoryHover}
      onMouseLeave={copilotStore.closeHistoryHover}
    >
      <button
        type="button"
        className="copilotHistory__newChat"
        disabled={copilotStore.streaming}
        onClick={() => {
          copilotStore.historyOpen = false;
          history.push("/copilot/new");
        }}
      >
        <i className="material-icons-outlined">add</i>
        <span>New chat</span>
      </button>
      <div className="copilotHistory__label">Recent</div>
      <div className="copilotHistory__list">
        {!copilotStore.conversations.length && (
          <div className="copilotHistory__empty">No conversations yet</div>
        )}
        {copilotStore.conversations.map(item => (
          <div
            key={item.id}
            className={`copilotHistory__item ${
              item.id === copilotStore.conversationId ? "active" : ""
            } ${editingId === item.id ? "editing" : ""}`}
            onClick={() => openChat(item.id)}
          >
            <div className="copilotHistory__itemMeta">
              {editingId === item.id ? (
                <input
                  className="copilotHistory__itemInput"
                  value={editValue}
                  autoFocus
                  onClick={event => event.stopPropagation()}
                  onChange={event => setEditValue(event.target.value)}
                  onBlur={commitEdit}
                  onKeyDown={event => {
                    if (event.key === "Enter") commitEdit();
                    else if (event.key === "Escape") cancelEdit();
                  }}
                />
              ) : (
                <span className="copilotHistory__itemTitle">
                  {item.title || "New conversation"}
                </span>
              )}
              <span className="copilotHistory__itemWhen">
                {formatWhen(item.lastActivityTs || item.ts)}
              </span>
            </div>
            {editingId !== item.id && (
              <div className="copilotHistory__itemActions">
                <i
                  className="material-icons-outlined copilotHistory__action"
                  title="Rename conversation"
                  onClick={event => {
                    event.stopPropagation();
                    startEdit(item);
                  }}
                >
                  edit
                </i>
                <i
                  className="material-icons-outlined copilotHistory__action copilotHistory__delete"
                  title="Delete conversation"
                  onClick={event => {
                    event.stopPropagation();
                    const wasActive = item.id === copilotStore.conversationId;
                    copilotStore.deleteConversation(item.id);
                    if (wasActive) history.push("/copilot/new");
                  }}
                >
                  delete
                </i>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
});

export default HistoryDrawer;
